import React from 'react';
import styled from 'styled-components';
import { sectionPaddings, standardColours } from '../styles';
import { Container } from './ui';
import TrustpilotWidget from './TrustpilotWidget';

const StyledReviewsCarousel = styled.section`
  ${sectionPaddings()};
  background-color: ${({ alt }) =>
    alt ? standardColours.white : standardColours.lightestGrey};
`;

const ReviewsCarousel = ({ alt }) => (
  <StyledReviewsCarousel alt={alt}>
    <Container wide={true}>
      <TrustpilotWidget type="carousel" />
    </Container>
  </StyledReviewsCarousel>
);

export default ReviewsCarousel;
